import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';

import SimpleHeader from '../../../main/headers/simpleHeader';
import Input from '../../../common/input';
import CancelButtonLink from '../../../common/buttons/cancelButtonLink';
import AdminActionButton from '../../shared/Buttons/AdminActionButton';
import AdminCustomerDuplicateForm from '../containers/AdminCustomerDuplicateForm';
import AdminDeleteButton from '../../shared/Buttons/AdminDeleteButton';
import AdminGDPRDeleteButton from '../../shared/Buttons/AdminGDPRDeleteButton';


const CustomerForm = ({ handleSubmit, submitting, valid, pristine, initialValues, deleteUser, gdprDeleteUser }) => (
  <div>
    <SimpleHeader heading={t('admin:customers.form.page_heading')} />
    <div className="c-inner-wrapper u-max-width-1050 u-mt">
      <form onSubmit={handleSubmit}>
        <fieldset disabled={submitting}>
          <span className="c-label-new">{t('admin:customers.form.username_label')}</span>
          <Input
            className="c-input"
            name="username"
            type="text"
            placeholder={t('admin:customers.form.name_placeholder')}
            autoComplete="off"
          />
          <div className="c-separator u-mv" />
          <div className="o-flexbox">
            <CancelButtonLink link="/customers" content={t('admin:customers.form.cancel_button')} />
            <div>
              <AdminDeleteButton
                onClick={deleteUser}
                className="c-btn c-btn--red u-mr-"
              />
              <AdminActionButton
                type="submit"
                className="c-btn u-width-120"
                disabled={pristine || !valid}
              >
                <span className="c-btn__text">{t('admin:customers.form.save_button')}</span>
              </AdminActionButton>
              <div>
                <AdminGDPRDeleteButton
                  onClick={gdprDeleteUser}
                  className="c-btn c-btn--grey c-btn--small u-mt-"
                />
              </div>
            </div>
          </div>
        </fieldset>
      </form>
      <AdminCustomerDuplicateForm user={initialValues} />
    </div>
  </div>
);

CustomerForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  deleteUser: PropTypes.func.isRequired,
  gdprDeleteUser: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  initialValues: PropTypes.object,
};

CustomerForm.defaultProps = {
  initialValues: {},
};

export default CustomerForm;
